import { render } from "./Cash.vue?vue&type=template&id=08c599c0&scoped=true"
import script from "./Cash.vue?vue&type=script&lang=js"
export * from "./Cash.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=08c599c0&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=1&id=08c599c0&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=08c599c0&scoped=true&lang=css"
import "@/assets/css/user/dark/payment-dark.css?vue&type=style&index=3&id=08c599c0&scoped=true&lang=css"
import "./Cash.vue?vue&type=style&index=4&id=08c599c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c599c0"]])

export default __exports__